module.exports = __webpack_public_path__ + "img/下对齐3.7ce38e59.svg";